import { LexicalEditor } from "lexical"
import { INSERT_INLINE_IMAGE_COMMAND } from "./InlineImagePlugin"
import ImageIcon from "@web/components/SVG/ImageIcon"
import { useTextEditorContext } from "../TextEditor.context"

interface Props {
  editor: LexicalEditor
}

export const ImageInput = ({ editor }: Props) => {
  const { disabledAssetTypes } = useTextEditorContext()

  return (
    <label>
      <input
        hidden
        type="file"
        accept=".jpg,.jpeg,.png,.gif,.webp"
        onChange={(e) => {
          const file = e.target.files?.[0]

          if (!file || disabledAssetTypes?.includes(file.type)) return

          editor.dispatchCommand(INSERT_INLINE_IMAGE_COMMAND, {
            src: URL.createObjectURL(file),
            fileName: file.name,
            fileType: file.type,
          })
        }}
      />
      <ImageIcon className="tmb-p-1 tmb-rounded-[4px] tmb-h-7 tmb-w-7 tmb-mt-1 tmb-cursor-pointer hover:tmb-bg-[#edeaea]" />
    </label>
  )
}
